export default __webpack_public_path__ + "static/media/Kategori Produk-DRINK WITH STYLE-2.e5692b00.jpg";